const message = {
  "button.home.sendFiles": "Send files",

  "button.options.record": "Record now",
  "button.options.upload": "Choose files",
  "button.options.gallery": "See album",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Photo Challenge",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Team Match",
  "button.options.foodMenu": "Menu",
  "button.options.schedule": "Schedule",
  "button.options.feed": "Party Feed",
  "message.options.bingoGame": "Play the party bingo!",
  "message.options.photoChallengeGame": "Join the photo challenge!",
  "message.options.quizGame": "Test your knowledge!",
  "message.options.teamMatchGame": "Which team are you part of?",
  "message.options.foodMenu": "Check out the party menu!",
  "message.options.schedule": "Check the event schedule!",
  "message.options.record": "Record your special message now!",
  "message.options.upload": "Share the best photos and videos of the party!",
  "message.options.gallery": "See the event photos!",
  "message.options.feed": "Follow the event's timeline!",

  "title.terms": "Terms of Use",
  "title.notFound": "Oops, it looks like this page does not exist.",
  "title.eventNotFound": "Error accessing the event",

  "subtitle.goBackTo": "Go back to",
  "subtitle.eventNotFound": "Event not found or expired.",

  "message.termsOfUse":
    "By using our system you agree to our <code>Terms of Use</code>",
  "message.termsFirstParagraph":
    "By using our photo and video submission system, you, as an event guest, agree that we collect and submit your data, including photos, videos and personal information, and make it available to the event host.",
  "message.termsSecondParagraph":
    "We do not access your files unless requested by the client to provide technical support, limited to what is necessary.",
  "message.termsThirdParagraph":
    "The company does not share data with third parties and maintains the confidentiality of information, except when required by law.",
  "message.shareLink": "Share your favorite moments from the party!",

  // recorder
  "button.recorder.home": "Home",
  "button.recorder.understood": "Understood!",
  "button.recorder.close": "Close",
  "button.recorder.share": "Share",
  "button.recorder.back": "Back",

  "title.recorder.permissionsToRecordAudioVideo": "Permission to Record",
  "title.recorder.success": "Success!",
  "title.recorder.uploading": "Uploading",
  "title.recorder.alert": "Alert!",
  "title.recorder.saving": "Saving",
  "title.recorder.waiting": "Waiting",
  "title.recorder.share": "Share!",
  "title.recorder.error": "Error!",
  "title.recorder.permissionCameraOrMicrophoneDenied": "Permission not granted",
  "title.recorder.terms": "Terms of Use",

  "subtitle.recorder.nextScreenClickAllow":
    "On the next screen click on <code>Allow</code>.",
  "subtitle.recorder.allowReinforcement":
    "It is necessary for you to click on <code>Allow</code> to record your message.",
  "subtitle.recorder.share": "Invite your friends to record too!",
  "subtitle.recorder.dontRefreshPage":
    "Please, do not refresh or close this page.",
  "subtitle.recorder.status.success":
    "Your message has been recorded successfully!",
  "subtitle.recorder.browserNotSupported":
    "Your browser is not supported or permission was not granted.",
  "subtitle.recorder.tryGrantPermission":
    "1. Refresh the page and allow the use of the camera.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Try using another browser like {chrome} or {safari}.",
  "subtitle.recorder.mustLongerThan":
    "The message must be longer than <code>5 seconds</code>.",
  "subtitle.recorder.offline": "You are offline. Please check your connection.",
  "subtitle.recorder.startRecord": "Click to start recording.",
  "subtitle.recorder.recording": "Recording...",
  "subtitle.recorder.uploadError": "Error uploading video.",
  "subtitle.recorder.tryAgain": "Check your connection and try again.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "Camera/microphone permission not granted.",
  "subtitle.recorder.trySafariBrowser":
    "1. Use the <code>SAFARI</code> browser",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Click on the <code>"aA"</code> button in the URL bar and on <code>"Site Settings"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Allow</code> the use of the camera and microphone",
  "subtitle.recorder.refreshPage": "4. Refresh the page",
  "subtitle.recorder.tryChromeBrowser":
    "1. Use the <code>CHROME</code> browser",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Access site settings and click on <code>"Permissions"</code>',

  "message.recorder.almostDone": "Almost done! Just a few more seconds.",
  "message.recorder.sendingMessage":
    "We are now sending your message. It may take a while because it's full of cool stuff.",

  "title.recorder.upload": "Upload",

  "subtitle.recorder.filesReadyToUpload": "File ready to upload:",

  "subtitle.recorder.fileWithError": "File that won’t be uploaded:",

  "message.recorder.fileSizeError": "File exceeds the allowed size limit",

  "button.recorder.send": "Send",

  "message.recorder.uploading": "Please do not refresh or close this page.",

  "message.recorder.uploadError": "Failed to upload.",

  "title.recorder.uploadFailure": "Upload Failed",

  "title.recorder.completed": "Completed",

  "message.recorder.uploadComplete": "Upload complete",

  "message.recorder.fileUploaded": "File successfully uploaded",

  "message.recorder.uploadFailed": "Failed to upload the file",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Please check your connection and try again",

  "button.recorder.ok": "OK!",

  "title.recorder.shareMoments": "Send Your Message",

  "subtitle.recorder.forThe1YearAnniversary": "For the 1-Year Anniversary",

  "subtitle.recorder.now": "For Now",

  "message.recorder.uploadMaxFilesLimit":
    "Upload <code>1 video</code> at a time.",

  "message.recorder.uploadLimit": "Maximum limit:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> per video.",

  "button.recorder.send_video": "Send Video",

  "message.recorder.uploadTip":
    "Click the button above and select the video you just recorded!",

  "title.recorder.guide.instructionsToRecord": "Recording Instructions",

  "subtitle.recorder.guide.instructions":
    "<code>Open the camera</code> on your device in selfie mode and record your message of up to <code>2 minutes</code>!",

  "subtitle.recorder.guide.moreInstructions":
    "Then come back here to send your message!",

  "message.recorder.instructions":
    "<code>Open your device's camera app</code> in selfie mode and record your message of up to <code>2 minutes</code>!",
  "button.recorder.sendVideo": "Send video",
  "message.recorder.uploadTip.ios":
    "💡 For better quality, select a video from your photo library",

  // uploader
  "button.uploader.send_photos": "Send photos",
  "button.uploader.send_video": "Send video",
  "button.uploader.close": "Close",
  "button.uploader.share": "Share",
  "button.uploader.back": "Back",
  "button.uploader.send": "Send",
  "button.uploader.continue": "Continue",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "Success!",
  "title.uploader.uploading": "Uploading",
  "title.uploader.alert": "Alert!",
  "title.uploader.saving": "Saving",
  "title.uploader.waiting": "Waiting",
  "title.uploader.share": "Share!",
  "title.uploader.error": "Error!",
  "title.uploader.upload": "Upload",
  "title.uploader.shareMoments": "Share the moment",
  "title.uploader.uploadFailure": "Upload failure",
  "title.uploader.completed": "Completed",
  "title.uploader.terms": "Terms of Use",

  "subtitle.uploader.filesWithError":
    "Files that <code>will not be sent</code>:",
  "subtitle.uploader.uploadHistory": "Completed uploads",
  "subtitle.uploader.filesReadyToUpload": "Files ready for upload:",

  "message.uploader.uploadMaxFilesLimit":
    "Send up to <code>50 photos or 1 video</code> at a time.",
  "message.uploader.uploadLimit": "Maximum limit:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> per photo",
  "message.uploader.videoSizeLimit": "<code>500MB</code> per video",
  "message.uploader.fileSizeError": "File exceeds allowed size.",
  "message.uploader.uploading": "Please, do not refresh or close this page.",
  "message.uploader.uploadError": "Failed to upload.",
  "message.uploader.maxFilesLimitError":
    "You can only upload <code>50 files at a time</code>.",
  "message.uploader.notFoundFilesToUpload": "<code>No files to upload.</code>",
  "message.uploader.checkFileSizeAndTryAgain":
    "Please, check the <code>file size </code> and try again.",
  "message.uploader.uploadComplete": "Upload completed",
  "message.uploader.allFilesUploaded": "All files uploaded",
  "message.uploader.nFilesUploaded": "{n} file(s) uploaded",
  "message.uploader.nFilesNotUploaded": "{n} file(s) not uploaded",
  "message.uploader.noFilesUploaded": "No files uploaded",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Check your connection and try again.",
  "message.uploader.uploadVerySlow":
    "If the upload is slow, select a few photos at a time",
  "message.uploader.uploadTip":
    "To maintain file quality, upload files from your device's gallery.",

  "title.guestForm": "Your Profile",
  "placeholder.guestForm.name": "Your name or nickname",
  "message.guestForm.nameRequired": "Name is required",
  "message.guestForm.dataInfo":
    "The provided data is not mandatory. They will be displayed only as a signature on the photos and videos you send.",
  "button.guestForm.takePhoto": "Take a selfie (optional)",
  "button.guestForm.submit": "Save",
  "button.guestForm.uploading": "Saving...",
  "button.guestForm.skip": "Continue anonymously",
  "message.cameraNotAvailable":
    "Unable to access the camera. Please make sure you have granted camera permissions.",
  "title.guestForm.cropPhoto": "Crop Photo",
  "button.guestForm.selectPhoto": "Select photo (optional)",

  "title.photoChallenge": "Photo Challenge",
  "subtitle.photoChallenge.tasks": "Tasks",
  "subtitle.photoChallenge.done": "Completed",
  "message.photoChallenge.intro":
    "The goal is to take photos as indicated in each objective.",
  "message.photoChallenge.todo": "Complete a challenge",
  "message.photoChallenge.done": "Challenges completed",
  "button.photoChallenge.start": "Start",

  "title.quiz": "Quiz",
  "subtitle.quiz.intro": "Do you accept the challenge?",
  "subtitle.quiz.result": "Result",
  "message.quiz.intro":
    "Among all the guests, prove that you are the person who knows the couple the best!",
  "button.quiz.start": "Start",
  "button.quiz.confirm": "Confirm",
  "message.quiz.result":
    "You got {score} out of {totalQuestions} questions right in {time} seconds",
  "message.quiz.saving": "Saving...",
  "button.quiz.share": "Share Result",
  "message.quiz.congrats": "🎉 Congratulations! 🎉",

  "message.bingo.intro":
    "Can you complete the bingo while having fun with each challenge?",
  "button.bingo.start": "Start",
  "label.bingo.fullCard": "Full Card",
  "label.bingo.line": "Line",
  "label.bingo.firstColumn": "1st - Column",
  "label.bingo.firstRow": "1st - Row",
  "subtitle.bingo.results": "Results",
  "message.bingo.selectChallenge": "Click to see and complete the challenge",
  "button.bingo.removeChallenge": "Remove challenge",
  "button.bingo.continue": "Continue",
  "message.bingo.progress": "Keep completing the bingo challenges!",
  "button.bingo.share": "Share",

  "message.photoChallenge.intro.new":
    "It's easy: follow the instructions and have fun taking photos!",
  "message.photoChallenge.inProgress.new":
    "Select a challenge below and submit your photo.",
  "button.photoChallenge.share": "Share Result",
  "message.photoChallenge.completed":
    "You completed all {total} photo challenges!",
  "message.photoChallenge.congrats": "🎉 Congratulations! 🎉",

  "title.teamMatch": "Team Match",
  "subtitle.teamMatch.intro": "Discover your team",
  "subtitle.teamMatch.result": "Result",
  "message.teamMatch.intro":
    "Take the test and find out if you are part of team {teamA} or team {teamB}!",
  "button.teamMatch.start": "Start",
  "button.teamMatch.next": "Next",
  "message.teamMatch.result": "Your team is <code>{team}</code>!",
  "message.teamMatch.saving": "Saving...",
  "button.teamMatch.share": "Share Result",

  "feed.loading": "Loading feed...",
  "feed.empty": "No items in the feed yet.",
  "feed.imageAlt": "Uploaded Image",
  "feed.anonymousGuest": "Anonymous Guest",
  "feed.imageUploader.title": "Uploaded Photo",

  "feed.quiz.title": "Quiz",
  "feed.quiz.description":
    "{guestName} completed the quiz! Result: {score}/{total} in {time} seconds",
  "feed.photoChallenge.title": "Photo Challenge",
  "feed.photoChallenge.description":
    "{guestName} completed the challenge: {challenge}",
  "feed.teamMatch.title": "Team Match",
  "feed.teamMatch.description":
    "{guestName} participated in Team Match. Result: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "New Guest",
  "feed.newGuest.description": "{guestName} joined the event",
  "feed.videoRecorder.title": "New Message",
  "feed.videoRecorder.description": "{guestName} sent a new message",
  "feed.default.title": "Activity",
  "feed.default.description": "A new activity occurred",
  //
  "feed.ctaPost.ctaButton": "Enjoying the event? Post a photo too!",
  "feed.imageUploader.description":
    "{guestName} uploaded files to the party gallery",
  "feed.cdt-imageUploader.title": "New Message",
  "feed.cdt-imageUploader.description":
    "{guestName} uploaded files for the 1-Year Anniversary!",
  "feed.quiz.ctaButton": "Test your knowledge",
  "feed.photoChallenge.ctaButton": "Join a challenge too",
  "feed.teamMatch.ctaButton": "Join the Team Match",
  "feed.videoRecorder.ctaButton": "Record a message now",
  "feed.videoUploader.title": "New Message",
  "feed.videoUploader.description":
    "{guestName} uploaded a video to the party gallery",
  "feed.cdt-videoUploader.title": "New Message",
  "feed.cdt-videoUploader.description":
    "{guestName} uploaded a video for the 1-Year Anniversary!",
  "feed.newPost.title": "New Post",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> has already left a message for the <code>1-Year Anniversary!</code>",
  "feed.cdtVideoRecorder.ctaButton": "Do the same!",
  "feed.placeholder.newPost": "Create post...",
  "feed.placeholder.newPostMessage": "Write your message...",

  "feed.menu.title.interaction": "Send files",
  "feed.menu.button.options.newPost": "Create post",
  "feed.menu.message.options.newPost": "Create a post right now!",
  "feed.menu.button.options.record": "Record now",
  "feed.menu.message.options.record": "Record your special message now!",
  "feed.menu.button.options.upload": "Choose files",
  "feed.menu.message.options.upload":
    "Share the best photos and videos from the party!",
  "feed.menu.title.gallery": "Party gallery",
  "feed.menu.button.options.gallery": "View album",
  "feed.menu.message.options.gallery": "See the event photos!",
  "feed.menu.title.games": "Games",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Play the party bingo!",
  "feed.menu.button.options.photoChallengeGame": "Photo challenge",
  "feed.menu.message.options.photoChallengeGame": "Join the photo challenge!",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "Test your knowledge!",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame": "Which team are you on?",
  "feed.menu.title.info": "About the event",
  "feed.menu.button.options.foodMenu": "Menu",
  "feed.menu.message.options.foodMenu": "Check out the party menu!",
  "feed.menu.button.options.schedule": "Schedule",
  "feed.menu.message.options.schedule": "See the party schedule!",
  "feed.menu.title.guestInfo": "Your information",
  "feed.menu.options.anonymousGuest": "Anonymous guest",
  "feed.menu.options.guestEditInfo": "Click to edit your information!",
  "feed.menu.title.other": "Other",
  "feed.menu.button.options.language": "Language",
  "feed.menu.message.options.languageInfo": "Click to change the language!",
  "feed.button.options.cancel": "Cancel",
  "feed.button.options.confirm": "Confirm",
  "feed.menu.button.options.share": "Share",
  "feed.menu.message.options.shareInfo": "Share the event link!",
  "feed.menu.button.options.about": "About the Time Capsule",
  "feed.menu.message.options.about": "Learn more about the Time Capsule!",
  "feed.createPost.title": "New Post",
  "feed.button.creatingPost": "Posting...",
  "feed.button.createPost": "Post",
  "feed.editImage.title": "Edit Image",
  "feed.newPost.selectImage": "Select image",
  "feed.createPost.info.sendingPostImage": "Sending image...",
  "feed.createPost.info.creatingPost": "Creating post...",
  "feed.createPost.info.finalizingPost": "Finalizing...",
  "feed.menu.button.options.games": "Games",
  "feed.modalGames.title": "Party Games",
  "feed.bingo.result.line": "Line",
  "feed.bingo.result.column": "Column",
  "feed.bingo.result.fullCard": "Full Card",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description": "{guestName} completed a {challenge} in the bingo",
  "feed.bingo.ctaButton": "Play bingo too",
  "feed.deletePost.title": "Delete Post",
  "feed.deletePost.message":
    "Are you sure you want to delete this post? This action cannot be undone.",
  //

  "title.uploader.modalMixedEventTitle":
    "WHEN do you want the couple to receive your photo or video?",
  "button.options.sendNow": "Send Now",
  "message.options.sendNow":
    "The couple will have access to the files immediately!",
  "button.options.sendLater": "On their 1st wedding anniversary",
  "message.options.sendLater": "Send to the event's Time Capsule!",

  "button.cancel": "Cancel",
  "button.delete": "Delete",
  "button.quiz.continue": "Continue",
  "button.recorder.recorder.back": "Back",
  "button.teamMatch.continue": "Continue",
  "cropper.remove.frame": "Remove Frame",
  "cropper.use.frame": "Use Frame",
  "error.guestForm.fileTooLarge": "The file must be at most 10MB",
  "error.guestForm.invalidFileType": "Please select a valid image file",
  "error.guestForm.removePhotoFailed":
    "Failed to remove photo. Please try again.",
  "error.guestForm.saveFailed": "Failed to save. Please try again.",
  "error.guestForm.updateFailed": "Failed to save. Please try again.",
  "error.guestForm.uploadFailed": "Photo upload failed. Please try again.",
  "title.guestForm.unsavedChanges": "Unsaved changes",
  "message.guestForm.unsavedChanges":
    "You have unsaved changes. Do you want to exit without saving?",
  "button.guestForm.cancel": "Cancel",
  "button.guestForm.exitWithoutSaving": "Exit without saving",
  "message.bingo.remove.warning":
    "By deleting this challenge, your results will be recalculated.",
  "message.bingo.remove.warning.detail1":
    "Rows and columns affected by the deletion will be reviewed.",
  "message.bingo.remove.warning.detail2":
    "If there are other completed achievements, the time will be updated to the current moment.",
  "message.guest.nameRequired": "Name is required",
  "message.quiz.progress":
    "The quiz is still going! Keep going and show what you're made of!",
  "message.teamMatch.progress":
    "The game is still going! Keep going and discover your team!",
  "title.feed": "Party Feed",
};

export default message;
